import {
  openHir,
  openIIm,
  slideLeft,
  slideRight,
} from '@jobseeker/lotus/assets/icons';
import {Image} from '@jobseeker/lotus/components/Image';
import {useEffect, useState} from 'react';
import Wrapper from '../Wrapper';
import {Box, Divider, IconButton, Typography} from '@mui/material';
import {Carousel, Dialog} from '@jobseeker/lotus/components';
import {
  useInView,
  useIsCustomWidth,
  useIsLargeDevice,
} from '@jobseeker/lotus/hooks';
import VideoModal from '../../VideoModal';
import VideoThumbnail from '../../VideoThumbnail';
import {AboutUs, JDQueryParams} from '../type';
import {ButtonV2, Tooltip, VersionVariants} from '@jobseeker/lotus/elements';
import {
  getKeyFromPath,
  TrackEventUBA,
  truncateHtmlAtWords,
} from '@jobseeker/common-core/utils';
import dynamic from 'next/dynamic';

const BottomSheet = dynamic(
  () => import('@jobseeker/lotus/elements/BottomSheet'),
  {ssr: false}
);

type About = {
  aboutCompany: AboutUs;
  url: string;
  templateInfo?: {
    templateNo?: string;
    origin?: string;
  };
  sourceAttr?: string;
  jobInfo?: any;
  jdQueryParams?: JDQueryParams;
  isAppIimjobs: boolean;
};
const AboutUsSection: React.FC<About> = ({
  aboutCompany,
  url,
  templateInfo,
  sourceAttr,
  jobInfo,
  jdQueryParams,
  isAppIimjobs,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [truncatedDescription, setTruncatedDescription] = useState('');
  const [showReadMore, setShowReadMore] = useState(false);
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const isLargeDevice = useIsLargeDevice(1200);
  const isExtraLarge = useIsLargeDevice(1400);
  const isMediumDevice = useIsLargeDevice(900);
  const isextraSmall = useIsLargeDevice(400);

  const videoItems = aboutCompany?.data?.companyCarouselVideos || [];
  const imgItems = aboutCompany?.data?.companyCarouselImages || [];
  const mediaItems = [...videoItems, ...imgItems];
  // const jobInfo: JobDetail = useSelector((state: AppState) => state.jobDetail);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeIndexTest, setActiveIndexTest] = useState(0);

  const handleVideoClick = (index: number) => {
    TrackEventUBA('jdPageClick', 'click', {
      ref: jdQueryParams?.ref || '',
      pageName: 'Job Description Page',
      jobID: jobInfo?.id,
      jobVersion: '',
      jobRef: getKeyFromPath('ref') || '',
      jobPos: jdQueryParams?.jobPos || '',
      page: 'JD',
      section: 'AboutCompany',
      isBranded: 'Yes',
      sessionUsername: sessionStorage.getItem('userId') || '',
      typeClick: 'AboutCompany-PlayVideo',
      companyID: jobInfo?.companyData?.companyId,
      centralCompanyID: jobInfo?.recruiter?.centralizedCompanyId,
      companyName: jobInfo?.companyData?.companyName,
      templateID: templateInfo?.templateNo,
    });
    const videoOnlyIndex = videoItems.findIndex(
      item => item === mediaItems[index]
    );
    setCurrentVideoIndex(videoOnlyIndex);
    setVideoModalOpen(true);
  };

  const handleImageClick = () => {
    TrackEventUBA('jdPageClick', 'click', {
      ref: jdQueryParams?.ref || '',
      pageName: 'Job Description Page',
      jobID: jobInfo?.id,
      jobVersion: '',
      jobRef: getKeyFromPath('ref') || '',
      jobPos: jdQueryParams?.jobPos || '',
      page: 'JD',
      section: 'AboutCompany',
      isBranded: 'Yes',
      sessionUsername: sessionStorage.getItem('userId') || '',
      typeClick: 'AboutCompany-Photos',
      companyID: jobInfo?.companyData?.companyId,
      centralCompanyID: jobInfo?.recruiter?.centralizedCompanyId,
      companyName: jobInfo?.companyData?.companyName,
      templateID: templateInfo?.templateNo,
    });
  };
  const handleVideoNavigation = (direction: 'prev' | 'next') => {
    if (direction === 'prev' && currentVideoIndex > 0) {
      setCurrentVideoIndex(currentVideoIndex - 1);
    } else if (
      direction === 'next' &&
      currentVideoIndex < videoItems.length - 1
    ) {
      setCurrentVideoIndex(currentVideoIndex + 1);
    }
  };
  const isSmall = useIsCustomWidth(700);
  const [testModuleOpen, setTestModuleOpen] = useState(false);
  const carouselElements = mediaItems.map((item, index) => {
    if (index < videoItems?.length) {
      return (
        <VideoThumbnail
          key={index}
          thumbnailUrl={item}
          title={item}
          width={
            isExtraLarge && isAppIimjobs ? 314 : isMediumDevice ? 300 : 168
          }
          height={isMediumDevice ? 180 : 106}
          onClick={() => handleVideoClick(index)}
        />
      );
    } else {
      return (
        <Box
          key={index}
          width={
            isExtraLarge && isAppIimjobs ? 314 : isMediumDevice ? 300 : 168
          }
          height={isMediumDevice ? 180 : 106}
          sx={{
            position: 'relative',
            borderRadius: 2.5,
            overflow: 'hidden',
            border: '0.8px solid rgba(126, 126, 126, 0.20)',
          }}
          onClick={() => handleImageClick()}
        >
          <Image
            src={item}
            key={index}
            alt={'img'}
            width={
              isExtraLarge && isAppIimjobs ? 314 : isMediumDevice ? 300 : 168
            }
            height={isMediumDevice ? 180 : 106}
            style={{borderRadius: '10px', objectFit: 'cover'}}
          />
        </Box>
      );
    }
  });
  useEffect(() => {
    if (aboutCompany?.companyDescription) {
      const fullText = aboutCompany?.companyDescription;
      const isHtml = /<[a-z][\s\S]*>/i.test(fullText);

      if (isHtml) {
        const wordCount = fullText
          .replace(/<[^>]*>/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
          .split(' ')
          .filter(w => w.length > 0).length;
        if (wordCount > 150) {
          setTruncatedDescription(truncateHtmlAtWords(fullText, 150));
          setShowReadMore(true);
        } else {
          setTruncatedDescription(fullText);
          setShowReadMore(false);
        }
      } else {
        const words = fullText.split(' ');
        if (words.length > 150) {
          setTruncatedDescription(words.slice(0, 150).join(' '));
          setShowReadMore(true);
        } else {
          setTruncatedDescription(fullText);
          setShowReadMore(false);
        }
      }
    }
  }, []);

  const toggleExpanded = () => {
    if (!expanded) {
      TrackEventUBA('jdPageClick', 'click', {
        ref: jdQueryParams?.ref || '',
        pageName: 'Job Description Page',
        jobID: jobInfo?.id,
        jobVersion: '',
        jobRef: getKeyFromPath('ref') || '',
        jobPos: jdQueryParams?.jobPos || '',
        page: 'JD',
        section: 'AboutCompany',
        isBranded: 'Yes',
        sessionUsername: sessionStorage.getItem('userId') || '',
        typeClick: 'AboutCompany-ReadMore',
        companyID: jobInfo?.companyData?.companyId,
        centralCompanyID: jobInfo?.recruiter?.centralizedCompanyId,
        companyName: jobInfo?.companyData?.companyName,
        templateID: templateInfo?.templateNo,
      });
    }
    setExpanded(!expanded);
  };

  const fullDescription = aboutCompany?.companyDescription || '';
  const isHtmlContent = /<[a-z][\s\S]*>/i.test(fullDescription);
  const description = expanded ? fullDescription : truncatedDescription;

  const {ref, isInView} = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  const [aboutCompanyTracked, setAboutCompanyTracked] = useState(false);
  useEffect(() => {
    if (isInView && !aboutCompanyTracked) {
      TrackEventUBA('sectionView', 'view', {
        ref: jdQueryParams?.ref || '',
        pageName: 'JD',
        jobID: jobInfo?.id,
        page: 'JD',
        templateID: templateInfo?.templateNo,
        isBranded: 'Yes',
        companyID: jobInfo?.companyData?.companyId,
        centralCompanyID: jobInfo?.recruiter?.centralizedCompanyId,
        companyName: jobInfo?.companyData?.companyName,
        section: 'AboutCompany',
        sessionUsername: sessionStorage.getItem('userId') || '',
      });
      if (url) {
        TrackEventUBA('sectionView', 'view', {
          ref: jdQueryParams?.ref || '',
          pageName: 'JD',
          jobID: jobInfo?.id,
          page: 'JD',
          templateID: templateInfo?.templateNo,
          isBranded: 'Yes',
          companyID: jobInfo?.companyData?.companyId,
          centralCompanyID: jobInfo?.recruiter?.centralizedCompanyId,
          companyName: jobInfo?.companyData?.companyName,
          section: 'ExploreCTA',
          sessionUsername: sessionStorage.getItem('userId') || '',
        });
      }
      setAboutCompanyTracked(true);
    }
  }, [isInView, aboutCompanyTracked]);

  const testCarouselElements =
    aboutCompany?.clientInsights?.testimonials?.map((testimonial, index) => {
      const tDesc = testimonial?.description || '';
      const tIsHtml = /<[a-z][\s\S]*>/i.test(tDesc);
      const tPlainLen = tIsHtml
        ? tDesc
            .replace(/<[^>]*>/g, '')
            .replace(/\s+/g, ' ')
            .trim().length
        : tDesc.length;
      const tIsTruncated = tPlainLen > 100;
      const tTruncated = tDesc.substr(0, 100);

      return (
        <Box
          sx={{
            border: '0.8px solid rgba(126, 126, 126, 0.20)',
            borderRadius: 4,
            p: 1.5,
            pb: 1.75,
            height: 124,
            width: {xxs: 210, md: 240},
            bgcolor: '#FFF',
          }}
        >
          <Tooltip title={testimonial?.name || ''} arrow>
            <Typography
              fontWeight={500}
              fontSize={{xxs: 12, md: 14}}
              sx={{
                maxWidth: '100%',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                cursor: 'pointer',
              }}
            >
              {testimonial?.name}
            </Typography>
          </Tooltip>
          <Box display={'flex'} mt={0.25}>
            <Typography fontWeight={400} fontSize={12}>
              {(testimonial?.designation?.length || 0) > 12
                ? `${testimonial?.designation?.slice(0, 12)}...`
                : testimonial?.designation}
            </Typography>
            <Divider
              orientation="vertical"
              flexItem
              sx={{
                mx: 1,
                height: 12,
                mt: '2.6px !important',
                mb: '0px !important',
                borderColor: '#EFEDFF',
              }}
            />
            <Typography fontWeight={400} fontSize={12}>
              {(testimonial?.companyName?.length || 0) > 12
                ? `${testimonial?.companyName?.slice(0, 12)}...`
                : testimonial?.companyName}
            </Typography>
          </Box>
          {tIsHtml ? (
            <Box
              sx={{
                fontSize: 12,
                fontWeight: 400,
                color: '#7E7E7E',
                mt: 1,
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                '& p': {my: 0},
                '& p:last-of-type': tIsTruncated ? {display: 'inline'} : {},
              }}
            >
              <Box
                component="span"
                dangerouslySetInnerHTML={{
                  __html: tIsTruncated ? tTruncated : tDesc,
                }}
              />
              {tIsTruncated && (
                <Box
                  component="span"
                  onClick={() => setTestModuleOpen(true)}
                  sx={{
                    display: 'inline',
                    cursor: 'pointer',
                    lineHeight: 'inherit',
                    color: 'primary.main',
                    userSelect: 'none',
                    fontWeight: 500,
                  }}
                >
                  ... Show More
                </Box>
              )}
            </Box>
          ) : (
            <Typography fontWeight={400} fontSize={12} color={'#7E7E7E'} mt={1}>
              <Box
                component="span"
                sx={{
                  display: 'inline',
                  overflowWrap: 'break-word',
                  wordBreak: 'break-word',
                }}
              >
                {tIsTruncated ? tTruncated : tDesc}
              </Box>
              {tIsTruncated && (
                <Box
                  component="span"
                  onClick={() => setTestModuleOpen(true)}
                  sx={{
                    display: 'inline',
                    cursor: 'pointer',
                    lineHeight: 'inherit',
                    color: 'primary.main',
                    userSelect: 'none',
                    fontWeight: 500,
                  }}
                >
                  ... Show More
                </Box>
              )}
            </Typography>
          )}
        </Box>
      );
    }) || [];
  return (
    <Box ref={ref}>
      <Dialog
        variant={VersionVariants.VERSION_THREE}
        open={!isSmall && testModuleOpen}
        onClose={() => {
          setTestModuleOpen(false);
        }}
        fullScreen={isSmall ? true : false}
        title={aboutCompany?.clientInsights?.heading || 'Client Testimonials'}
        sx={{
          '& .MuiDialog-paper': {
            minWidth: {xxs: '100%', md: 962},
            height: {xxs: '100%', md: 582},
            borderRadius: {xxs: 0, md: 5},
            backgroundColor: {xxs: 'black', md: 'white'},
          },
          '& .MuiDialogContent-root': {
            px: 3,
            pb: {xxs: 0, md: 0.5},
          },
        }}
        titleProps={{
          mt: {xxs: 2, md: 2},
          mb: 1,
          ml: 3,
          p: 0,
        }}
        titleBoxProps={{
          borderBottomLeftRadius: isSmall ? 12 : 0,
          borderBottomRightRadius: isSmall ? 12 : 0,
          backgroundColor: 'white',
        }}
      >
        {aboutCompany?.clientInsights?.testimonials?.map(
          (testimonial, index) => (
            <Box
              sx={{
                border: '0.8px solid rgba(126, 126, 126, 0.20)',
                borderRadius: 4,
                p: 1.5,
                bgcolor: '#FFF',
                mt: 1.5,
                mb:
                  index ===
                  (aboutCompany?.clientInsights?.testimonials?.length || 0) - 1
                    ? 2
                    : 0,
              }}
            >
              <Tooltip title={testimonial?.name || ''} arrow>
                <Typography
                  fontWeight={500}
                  fontSize={{xxs: 12, md: 14}}
                  sx={{
                    maxWidth: '100%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer',
                  }}
                >
                  {testimonial?.name}
                </Typography>
              </Tooltip>
              <Box display={'flex'} mt={0.25}>
                <Typography fontWeight={400} fontSize={12}>
                  {testimonial?.designation}
                </Typography>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    mx: 1,
                    height: 12,
                    mt: '2.6px !important',
                    mb: '0px !important',
                    borderColor: '#EFEDFF',
                  }}
                />
                <Typography fontWeight={400} fontSize={12}>
                  {testimonial?.companyName}
                </Typography>
              </Box>
              {/<[a-z][\s\S]*>/i.test(testimonial?.description || '') ? (
                <Box
                  dangerouslySetInnerHTML={{
                    __html: testimonial?.description || '',
                  }}
                  sx={{
                    fontSize: 12,
                    fontWeight: 400,
                    color: '#7E7E7E',
                    mt: 1,
                    overflowWrap: 'break-word',
                    wordBreak: 'break-word',
                  }}
                />
              ) : (
                <Typography
                  fontWeight={400}
                  fontSize={12}
                  color={'#7E7E7E'}
                  mt={1}
                  sx={{whiteSpace: 'pre-line'}}
                >
                  {testimonial?.description}
                </Typography>
              )}
            </Box>
          )
        )}
      </Dialog>
      <BottomSheet
        maxHeight={600}
        open={isSmall && testModuleOpen}
        title={aboutCompany?.clientInsights?.heading || 'Client Testimonials'}
        onDismiss={() => {
          setTestModuleOpen(false);
        }}
      >
        {aboutCompany?.clientInsights?.testimonials?.map(
          (testimonial, index) => (
            <Box
              sx={{
                border: '0.8px solid rgba(126, 126, 126, 0.20)',
                borderRadius: 4,
                p: 1.5,
                bgcolor: '#FFF',
                mt: 2,
                mb:
                  index ===
                  (aboutCompany?.clientInsights?.testimonials?.length || 0) - 1
                    ? 2
                    : 0,
                mx: 1.5,
              }}
            >
              <Tooltip title={testimonial?.name || ''} arrow>
                <Typography
                  fontWeight={500}
                  fontSize={{xxs: 12, md: 14}}
                  sx={{
                    maxWidth: '100%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer',
                  }}
                >
                  {testimonial?.name}
                </Typography>
              </Tooltip>
              <Box display={'flex'} mt={0.25}>
                <Typography
                  fontWeight={400}
                  fontSize={12}
                  sx={{
                    whiteSpace: 'pre-line',
                  }}
                >
                  {testimonial?.designation}
                </Typography>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    mx: 1,
                    height: 12,
                    mt: '2.6px !important',
                    mb: '0px !important',
                    borderColor: '#EFEDFF',
                  }}
                />
                <Typography fontWeight={400} fontSize={12}>
                  {testimonial?.companyName}
                </Typography>
              </Box>
              {/<[a-z][\s\S]*>/i.test(testimonial?.description || '') ? (
                <Box
                  dangerouslySetInnerHTML={{
                    __html: testimonial?.description || '',
                  }}
                  sx={{
                    fontSize: 12,
                    fontWeight: 400,
                    color: '#7E7E7E',
                    mt: 1,
                    overflowWrap: 'break-word',
                    wordBreak: 'break-word',
                  }}
                />
              ) : (
                <Typography
                  fontWeight={400}
                  fontSize={12}
                  color={'#7E7E7E'}
                  mt={1}
                >
                  {testimonial?.description}
                </Typography>
              )}
            </Box>
          )
        )}
      </BottomSheet>
      <VideoModal
        open={videoModalOpen}
        onClose={() => setVideoModalOpen(false)}
        videoUrl={videoItems[currentVideoIndex] || ''}
        title={videoItems[currentVideoIndex] || ''}
        currentIndex={currentVideoIndex}
        totalItems={videoItems.length}
        onPrevious={() => handleVideoNavigation('prev')}
        onNext={() => handleVideoNavigation('next')}
      />
      {!isAppIimjobs && (
        <Typography
          lineHeight={{xxs: '16px', md: '20px'}}
          sx={{
            objectFit: 'cover',
            m: 3,
            mb: 1,
            ml: 0,
            mx: {xxs: isAppIimjobs ? 0 : 2, md: 0},
            fontSize: 16,
            fontWeight: 600,
          }}
        >
          About the Company
        </Typography>
      )}
      <Wrapper
        heading={
          isAppIimjobs ? (
            <Typography
              variant="subtitle2"
              lineHeight={{xxs: '16px', md: '20px'}}
              fontSize={{xxs: 14, md: 16}}
              sx={{
                objectFit: 'cover',
                m: {xxs: 1.5, md: 3},
                mb: {xxs: 0.5, md: 1},
                mt: {xxs: 2, md: 3},
              }}
            >
              About the Company
            </Typography>
          ) : (
            <Box mt={isAppIimjobs ? 1 : {xxs: -1, md: 1}}></Box>
          )
        }
        component={
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1.5,
              m: {xxs: 1.5, md: 3},
              mt: isAppIimjobs ? '0px !important' : '12px !important',
              backgroundImage: '',

              backgroundPosition: 'right bottom',
              backgroundSize: {
                xxs: isAppIimjobs
                  ? aboutCompany?.clientInsights?.testimonials?.length
                    ? '400px 320px'
                    : '190px 140px'
                  : '400px 320px',
                md: isAppIimjobs
                  ? aboutCompany?.clientInsights?.testimonials?.length
                    ? '440px 400px'
                    : '440px 220px'
                  : '675px 350px',
              },
              backgroundRepeat: 'no-repeat',
              backgroundPositionX: {
                xxs: isAppIimjobs
                  ? aboutCompany?.clientInsights?.testimonials?.length
                    ? 'calc(100% + 200px)'
                    : ''
                  : 'calc(100% + 200px)',
                md: isAppIimjobs
                  ? aboutCompany?.clientInsights?.testimonials?.length
                    ? 'right'
                    : ''
                  : 'calc(100% + 80px)',
              },
              backgroundPositionY: {
                xxs: isAppIimjobs
                  ? aboutCompany?.clientInsights?.testimonials?.length
                    ? ''
                    : ''
                  : 'calc(100% + 190px)',
                md: isAppIimjobs
                  ? aboutCompany?.clientInsights?.testimonials?.length
                    ? ''
                    : ''
                  : 'calc(100% + 130px)',
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: {xxs: 'column', md: 'row'},
                justifyContent: 'space-between',
                alignItems: {xxs: 'none', md: 'center'},
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: {
                    xxs: 'start',
                    md: isAppIimjobs ? 'center' : 'start',
                  },
                }}
              >
                <Image
                  src={aboutCompany?.companyLogo || ''}
                  alt={jobInfo?.companyData?.companyName || ''}
                  width={50}
                  height={50}
                  style={{
                    borderRadius: '12px',
                    marginTop: isSmall ? 8 : 0,
                    border:
                      '0.6px solid var(--Outlines-Dividers, rgba(126, 126, 126, 0.20))',
                  }}
                />
                <Box sx={{p: 1, pt: isAppIimjobs ? '8px' : {xxs: 1, md: 0.5}}}>
                  <Typography
                    sx={{
                      fontSize: isAppIimjobs
                        ? {xxs: 14, md: 16}
                        : {xxs: 16, md: 18},
                      fontWeight: 500,
                    }}
                    lineHeight={'18px'}
                  >
                    {aboutCompany?.companyName}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: isAppIimjobs ? 14 : {xxs: 14, md: 16},
                      fontWeight: isAppIimjobs ? 300 : 400,
                      // fontStyle: 'italic',
                      letterSpacing: '0.14px',
                      mt: isAppIimjobs ? 0.75 : 1,
                      lineHeight: '16px',
                    }}
                  >
                    {aboutCompany?.companySubheading}
                  </Typography>
                </Box>
              </Box>
              {url && url !== '' && (
                <ButtonV2
                  variant="outlined"
                  color="primary"
                  href={url}
                  target="_blank"
                  onClick={() => {
                    TrackEventUBA('jdPageClick', 'click', {
                      ref: jdQueryParams?.ref || '',
                      pageName: 'Job Description Page',
                      jobID: jobInfo?.id,
                      jobVersion: '',
                      jobRef: getKeyFromPath('ref') || '',
                      jobPos: jdQueryParams?.jobPos || '',
                      page: 'JD',
                      section: 'ExploreCTA',
                      isBranded: 'Yes',
                      sessionUsername: sessionStorage.getItem('userId') || '',
                      typeClick: '',
                      companyID: jobInfo?.companyData?.companyId,
                      centralCompanyID:
                        jobInfo?.recruiter?.centralizedCompanyId,
                      companyName: jobInfo?.companyData?.companyName,
                      templateID: templateInfo?.templateNo,
                    });
                  }}
                  sx={{
                    ml: {xxs: 7, md: 0},
                    width: {xxs: 170, md: 190},
                    borderRadius: isAppIimjobs ? '100px' : '4px',
                    backgroundColor: isAppIimjobs ? 'transparent' : 'white',
                    px: 0,
                  }}
                >
                  <Typography
                    variant={isMediumDevice ? 'subtitle2' : 'subtitle3'}
                    lineHeight={{xxs: '16px', md: '20px'}}
                  >
                    Explore the Company
                  </Typography>
                  <Image
                    src={isAppIimjobs ? openIIm : openHir}
                    height={12}
                    width={12}
                    alt=""
                    style={{marginLeft: '4px'}}
                  />
                </ButtonV2>
              )}
            </Box>
            {isHtmlContent ? (
              <Box
                sx={{
                  fontSize: isAppIimjobs ? 14 : {xxs: 14, md: 16},
                  fontWeight: 400,
                  lineHeight: {
                    xxs: isAppIimjobs ? '20px' : '22px',
                    md: isAppIimjobs ? '20px' : '24px',
                  },
                  letterSpacing: '0.12px',
                  overflowWrap: 'break-word',
                  wordBreak: 'break-word',
                  '& p': {my: 0},
                  '& p:last-of-type': showReadMore ? {display: 'inline'} : {},
                }}
              >
                <Box
                  component="span"
                  dangerouslySetInnerHTML={{__html: description}}
                />
                {showReadMore && (
                  <Box
                    component="span"
                    onClick={toggleExpanded}
                    sx={{
                      display: 'inline',
                      cursor: 'pointer',
                      ml: 0.25,
                      lineHeight: 'inherit',
                      color: 'primary.main',
                      userSelect: 'none',
                      fontWeight: 500,
                    }}
                  >
                    {expanded ? ' Read Less' : ' Read More'}
                  </Box>
                )}
              </Box>
            ) : (
              <Typography
                component="span"
                sx={{
                  display: 'inline',
                  fontSize: isAppIimjobs ? 14 : {xxs: 14, md: 16},
                  fontWeight: 400,
                  lineHeight: {
                    xxs: isAppIimjobs ? '20px' : '22px',
                    md: isAppIimjobs ? '20px' : '24px',
                  },
                  letterSpacing: '0.12px',
                  verticalAlign: 'middle',
                }}
              >
                <Box
                  component="span"
                  sx={{
                    display: 'inline',
                    overflowWrap: 'break-word',
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-line',
                  }}
                >
                  {description}
                </Box>
                {showReadMore && (
                  <Box
                    component="span"
                    onClick={toggleExpanded}
                    sx={{
                      display: 'inline',
                      cursor: 'pointer',
                      ml: 0.25,
                      lineHeight: 'inherit',
                      color: 'primary.main',
                      userSelect: 'none',
                      fontWeight: 500,
                    }}
                  >
                    {expanded ? ' Read Less' : ' Read More'}
                  </Box>
                )}
              </Typography>
            )}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1.25,
                mt: {xxs: 0, md: 2},
              }}
            >
              {carouselElements?.length > 0 && (
                <Typography
                  letterSpacing={'0.14px'}
                  lineHeight={{xxs: '16px', md: '18px'}}
                  sx={{
                    fontSize: isAppIimjobs ? 14 : {xxs: 16, md: 18},
                    fontWeight: isAppIimjobs ? 500 : 600,
                  }}
                >
                  {aboutCompany?.data?.companyCarouselHeading ||
                    'Company Spotlight!'}
                </Typography>
              )}
              <Box
                overflow="hidden"
                position="relative"
                sx={{
                  '.carousel-nav-button': {
                    opacity: 1,
                  },
                }}
              >
                {!isSmall && (
                  <IconButton
                    disableRipple
                    disableFocusRipple
                    className="previous-featured-course carousel-nav-button"
                    onClick={() => {
                      setActiveIndex(activeIndex - 1);
                    }}
                    sx={{
                      position: 'absolute',
                      left: isAppIimjobs ? 0 : -8,
                      top: '50%',
                      display: {
                        xxs: carouselElements?.length > 1 ? 'block' : 'none',
                        md:
                          carouselElements?.length > 2 && activeIndex > 0
                            ? 'block'
                            : 'none',
                        xl:
                          carouselElements?.length > (isAppIimjobs ? 3 : 2) &&
                          activeIndex > 0
                            ? 'block'
                            : 'none',
                      },
                      transform: 'translateY(-42%)',
                      zIndex: 2,
                      objectFit: 'cover',

                      ':hover': {backgroundColor: 'transparent'},
                    }}
                  >
                    <Image
                      src={slideLeft}
                      width={42}
                      height={42}
                      alt="left"
                      objectFit="contain"
                      style={{
                        filter:
                          'drop-shadow(0px 2.4px 2.4px rgba(0, 0, 0, 0.25))',
                      }}
                    />
                  </IconButton>
                )}
                <Carousel
                  swiperProps={{slidesOffsetAfter: 10}}
                  brandedJd={true}
                  carouselItems={carouselElements}
                  fullFrame={false}
                  showPagination={false}
                  slidesPerView={
                    isLargeDevice
                      ? 1
                      : isMediumDevice
                        ? 1
                        : isextraSmall
                          ? 1.9
                          : 1.9
                  }
                  next=".next-featured-course"
                  previous=".previous-featured-course"
                  breakpointOverrides={{
                    360: {
                      slidesPerView: isAppIimjobs ? 1.7 : 1.8,
                      spaceBetween: 14,
                    },
                    380: {
                      slidesPerView: isAppIimjobs ? 1.9 : 2,
                      spaceBetween: 14,
                    },
                    400: {
                      slidesPerView: isAppIimjobs ? 2 : 2.1,
                      spaceBetween: 14,
                    },
                    420: {
                      slidesPerView: isAppIimjobs ? 2.1 : 2.2,
                      spaceBetween: 14,
                    },
                    480: {
                      slidesPerView: isAppIimjobs ? 2 : 2.2,
                      spaceBetween: 14,
                    },

                    768: {slidesPerView: 2, spaceBetween: 14},
                    1024: {
                      slidesPerView: isAppIimjobs ? 2.1 : 1.4,
                      spaceBetween: 14,
                    },
                    1100: {
                      slidesPerView: isAppIimjobs ? 2.6 : 1.5,
                      spaceBetween: 14,
                    },
                    1200: {
                      slidesPerView: isAppIimjobs ? 2.6 : 2,
                      spaceBetween: 14,
                    },

                    1280: {
                      slidesPerView: isAppIimjobs ? 2.6 : 2.3,
                      spaceBetween: 14,
                    },
                    1336: {
                      slidesPerView: isAppIimjobs ? 2.6 : 2.4,
                      spaceBetween: 14,
                    },

                    1440: {
                      slidesPerView: isAppIimjobs ? 3.1 : 2.8,
                      spaceBetween: 14,
                    },
                    1550: {
                      slidesPerView: isAppIimjobs ? 3.1 : 2.8,
                      spaceBetween: 18,
                    },
                  }}
                />
                {!isSmall && (
                  <IconButton
                    disableRipple
                    disableFocusRipple
                    className="next-featured-course carousel-nav-button"
                    onClick={() => {
                      setActiveIndex(activeIndex + 1);
                    }}
                    sx={{
                      display: {
                        xxs: carouselElements?.length > 1 ? 'block' : 'none',
                        md:
                          carouselElements?.length > 2 &&
                          (isAppIimjobs ||
                            !(activeIndex >= carouselElements.length - 1))
                            ? 'block'
                            : 'none',
                        xl:
                          carouselElements?.length > (isAppIimjobs ? 3 : 2) &&
                          (isAppIimjobs ||
                            !(
                              activeIndex >=
                              carouselElements.length - (isAppIimjobs ? 3 : 2)
                            ))
                            ? 'block'
                            : 'none',
                      },
                      position: 'absolute',
                      right: isAppIimjobs ? 0 : -8,
                      top: '50%',
                      transform: 'translateY(-42%)',
                      zIndex: 2,
                      ':hover': {backgroundColor: 'transparent'},
                    }}
                  >
                    <Image
                      src={slideRight}
                      width={42}
                      height={42}
                      alt="right"
                      style={{
                        filter:
                          'drop-shadow(0px 2.4px 2.4px rgba(0, 0, 0, 0.25))',
                      }}
                    />
                  </IconButton>
                )}
              </Box>
            </Box>
            {(aboutCompany?.clientInsights?.testimonials?.length || 0) > 0 && (
              <Box mt={2}>
                {(aboutCompany?.clientInsights?.testimonials?.length || 0) >
                  0 && (
                  <Typography
                    letterSpacing={'0.14px'}
                    lineHeight={{xxs: '16px', md: '18px'}}
                    sx={{
                      fontSize: isAppIimjobs ? 14 : {xxs: 16, md: 18},
                      fontWeight: isAppIimjobs ? 500 : 600,
                      mb: 1.5,
                    }}
                  >
                    {aboutCompany?.clientInsights?.heading ||
                      'Company Spotlight!'}
                  </Typography>
                )}
                <Box
                  overflow="hidden"
                  position="relative"
                  sx={{
                    '.carousel-nav-button': {
                      opacity: 1,
                    },
                  }}
                >
                  {!isSmall && (
                    <IconButton
                      disableRipple
                      disableFocusRipple
                      className="previous-featured-test carousel-nav-button"
                      onClick={() => {
                        setActiveIndexTest(activeIndexTest - 1);
                      }}
                      sx={{
                        position: 'absolute',
                        left: isAppIimjobs ? 0 : -8,
                        top: '50%',
                        display: {
                          xxs: carouselElements?.length > 1 ? 'block' : 'none',
                          md:
                            testCarouselElements?.length > 2 &&
                            activeIndexTest > 0
                              ? 'block'
                              : 'none',
                          lg:
                            testCarouselElements?.length >
                              (isAppIimjobs ? 3 : 2) && activeIndexTest > 0
                              ? 'block'
                              : 'none',
                        },
                        transform: 'translateY(-42%)',
                        zIndex: 2,
                        objectFit: 'cover',

                        ':hover': {backgroundColor: 'transparent'},
                      }}
                    >
                      <Image
                        src={slideLeft}
                        width={42}
                        height={42}
                        alt="left"
                        objectFit="contain"
                        style={{
                          filter:
                            'drop-shadow(0px 2.4px 2.4px rgba(0, 0, 0, 0.25))',
                        }}
                      />
                    </IconButton>
                  )}
                  <Carousel
                    swiperProps={{slidesOffsetAfter: 10}}
                    brandedJd={true}
                    carouselItems={testCarouselElements}
                    fullFrame={false}
                    showPagination={false}
                    slidesPerView={
                      isLargeDevice
                        ? 1
                        : isMediumDevice
                          ? 1
                          : isextraSmall
                            ? 1.9
                            : 1.9
                    }
                    next=".next-featured-test"
                    previous=".previous-featured-test"
                    breakpointOverrides={{
                      360: {
                        slidesPerView: isAppIimjobs ? 1.2 : 1.3,
                        spaceBetween: 14,
                      },
                      380: {
                        slidesPerView: isAppIimjobs ? 1.3 : 1.4,
                        spaceBetween: 14,
                      },
                      400: {
                        slidesPerView: isAppIimjobs ? 1.4 : 1.5,
                        spaceBetween: 14,
                      },
                      420: {
                        slidesPerView: isAppIimjobs ? 1.5 : 1.6,
                        spaceBetween: 14,
                      },
                      480: {
                        slidesPerView: isAppIimjobs ? 1.7 : 1.8,
                        spaceBetween: 14,
                      },

                      768: {slidesPerView: 1.7, spaceBetween: 14},
                      1024: {
                        slidesPerView: isAppIimjobs ? 2.2 : 1.6,
                        spaceBetween: 14,
                      },
                      1100: {
                        slidesPerView: isAppIimjobs ? 2.4 : 1.7,
                        spaceBetween: 14,
                      },
                      1190: {
                        slidesPerView: isAppIimjobs ? 2.7 : 2.2,
                        spaceBetween: 14,
                      },

                      1280: {
                        slidesPerView: isAppIimjobs ? 3 : 2.5,
                        spaceBetween: 14,
                      },
                      1336: {
                        slidesPerView: isAppIimjobs ? 3.3 : 2.7,
                        spaceBetween: 14,
                      },

                      1440: {
                        slidesPerView: isAppIimjobs ? 3.5 : 3.2,
                        spaceBetween: 14,
                      },
                      1550: {
                        slidesPerView: isAppIimjobs ? 3.5 : 3.2,
                        spaceBetween: 18,
                      },
                    }}
                  />
                  {!isSmall && (
                    <IconButton
                      disableRipple
                      disableFocusRipple
                      className="next-featured-test carousel-nav-button"
                      onClick={() => {
                        setActiveIndexTest(activeIndexTest + 1);
                      }}
                      sx={{
                        display: {
                          xxs:
                            testCarouselElements?.length > 1 ? 'block' : 'none',
                          md:
                            testCarouselElements?.length > 2 &&
                            (isAppIimjobs ||
                              !(
                                activeIndexTest >=
                                testCarouselElements.length - 1
                              ))
                              ? 'block'
                              : 'none',
                          lg:
                            testCarouselElements?.length >
                              (isAppIimjobs ? 3 : 2) &&
                            (isAppIimjobs ||
                              !(
                                activeIndexTest >=
                                testCarouselElements.length -
                                  (isAppIimjobs ? 3 : 2)
                              ))
                              ? 'block'
                              : 'none',
                        },
                        position: 'absolute',
                        right: isAppIimjobs ? 0 : -8,
                        top: '50%',
                        transform: 'translateY(-42%)',
                        zIndex: 2,
                        ':hover': {backgroundColor: 'transparent'},
                      }}
                    >
                      <Image
                        src={slideRight}
                        width={42}
                        height={42}
                        alt="right"
                        style={{
                          filter:
                            'drop-shadow(0px 2.4px 2.4px rgba(0, 0, 0, 0.25))',
                        }}
                      />
                    </IconButton>
                  )}
                </Box>
                <Typography
                  mt={0.5}
                  fontSize={10}
                  fontWeight={400}
                  color={'#6E7287'}
                  sx={{
                    overflowWrap: 'anywhere',
                    wordBreak: 'break-word',
                  }}
                >
                  {sourceAttr}
                </Typography>
              </Box>
            )}
          </Box>
        }
        isAppIimjobs={isAppIimjobs}
      />
    </Box>
  );
};

export default AboutUsSection;
